exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@keyframes fadeIn {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n.node-content {\n  margin-bottom: 25px;\n  padding: 35px;\n  border: solid 1px black;\n  font-family: \"VT323\", monospace;\n  background-color: black;\n  color: #fff;\n  font-size: 1.25rem;\n  white-space: pre-wrap;\n  border-radius: 0.3rem;\n  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2); }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/Story/NodeContent/NodeContent.scss
// module id = 144
// module chunks = 0